"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("reshow-runtime/helpers/objectSpread2"));
var _reshowConstant = require("reshow-constant");
var _mergeDefaultValue = _interopRequireDefault(require("../../mergeDefaultValue.js"));
//@ts-check

/**
 * @param {object} styles
 * @param {object} defaultStyles
 * @param {object} injectStyles
 */
var mergeStyleConfig = function mergeStyleConfig(styles, defaultStyles, injectStyles) {
  if (defaultStyles) {
    (0, _mergeDefaultValue["default"])(styles, defaultStyles);
  }
  if (injectStyles) {
    (0, _reshowConstant.KEYS)(styles).forEach(function (key) {
      if (injectStyles[key]) {
        injectStyles[key][0] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, injectStyles[key][0]), styles[key]);
      }
    });
  }
};
var _default = exports["default"] = mergeStyleConfig;
module.exports = exports.default;